import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { useAuthStore } from './stores/auth'
import websocketPlugin from './plugins/websocket'
import { webFormsPlugin } from '@getodk/web-forms'

const app = createApp(App)

// Initialize stores and plugins
app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(websocketPlugin)
app.use(webFormsPlugin)

// Initialize authentication when the application starts
const authStore = useAuthStore()

// Wrap async initialization in a function
async function initializeApp() {
  try {
    await authStore.initAuth()
  } catch (error) {
    console.error('[Main] Auth initialization failed:', error)
  }

  const gtmKey = import.meta.env.VITE_APP_GTM_KEY
  if (import.meta.env.VITE_APP_GTM_ENABLED && gtmKey) {
    app.use(
      createGtm({
        id: gtmKey,
        debug: false,
        vueRouter: router,
      }),
    )
  }

  // Mount the application after initialization
  app.mount('#app')
}

// Start the application
initializeApp()
